// Shared gate position data used by ConcourseMap and RouteMapModal

export const WEST_PROPORTION = 33;
export const EAST_PROPORTION = 67;

// Each gate: { wing, side, left }
// wing: 'west' or 'east'
// side: 'north' (odd gates, top) or 'south' (even gates, bottom)
// left: CSS percentage position within that wing
export const GATE_POSITIONS = {
  // North side (odd) - west wing
  23: { wing: 'west', side: 'north', left: '0%' },
  25: { wing: 'west', side: 'north', left: '10%' },
  27: { wing: 'west', side: 'north', left: '20%' },
  29: { wing: 'west', side: 'north', left: '30%' },
  31: { wing: 'west', side: 'north', left: '40%' },
  33: { wing: 'west', side: 'north', left: '57%' },
  35: { wing: 'west', side: 'north', left: '67.5%' },
  37: { wing: 'west', side: 'north', left: '78%' },
  39: { wing: 'west', side: 'north', left: '88.5%' },

  // North side (odd) - east wing
  41: { wing: 'east', side: 'north', left: '2%' },
  43: { wing: 'east', side: 'north', left: '8%' },
  45: { wing: 'east', side: 'north', left: '14%' },
  47: { wing: 'east', side: 'north', left: '20%' },
  49: { wing: 'east', side: 'north', left: '29.7%' },
  51: { wing: 'east', side: 'north', left: '37.1%' },
  53: { wing: 'east', side: 'north', left: '44%' },
  55: { wing: 'east', side: 'north', left: '50.6%' },
  57: { wing: 'east', side: 'north', left: '60.3%' },
  59: { wing: 'east', side: 'north', left: '67.4%' },
  61: { wing: 'east', side: 'north', left: '74%' },
  63: { wing: 'east', side: 'north', left: '80.6%' },
  65: { wing: 'east', side: 'north', left: '90%' },
  67: { wing: 'east', side: 'north', left: '95%' },

  // South side (even) - west wing
  24: { wing: 'west', side: 'south', left: '0%' },
  26: { wing: 'west', side: 'south', left: '14%' },
  28: { wing: 'west', side: 'south', left: '27%' },
  30: { wing: 'west', side: 'south', left: '40%' },
  32: { wing: 'west', side: 'south', left: '57%' },
  34: { wing: 'west', side: 'south', left: '67.5%' },
  36: { wing: 'west', side: 'south', left: '78%' },
  38: { wing: 'west', side: 'south', left: '88.5%' },

  // South side (even) - east wing
  40: { wing: 'east', side: 'south', left: '2%' },
  42: { wing: 'east', side: 'south', left: '8%' },
  44: { wing: 'east', side: 'south', left: '14%' },
  46: { wing: 'east', side: 'south', left: '20%' },
  48: { wing: 'east', side: 'south', left: '29.7%' },
  50: { wing: 'east', side: 'south', left: '37.1%' },
  52: { wing: 'east', side: 'south', left: '44%' },
  54: { wing: 'east', side: 'south', left: '50.6%' },
  56: { wing: 'east', side: 'south', left: '60.3%' },
  58: { wing: 'east', side: 'south', left: '67.4%' },
  60: { wing: 'east', side: 'south', left: '74%' },
  62: { wing: 'east', side: 'south', left: '80.6%' },
  64: { wing: 'east', side: 'south', left: '90%' },
  66: { wing: 'east', side: 'south', left: '95%' },
};

export const TUNNELS = [
  { position: 31.3, label: 'West Tunnel', section: 'west' },
  { position: 47.2, label: 'East Tunnel', section: 'east' },
  { position: 55.5, label: '', section: 'east' },
  { position: 63.5, label: '', section: 'east' }
];
